// @ts-nocheck
import angular from "angular";
import * as _ from "lodash";
const _Bloodhound = require('bloodhound-js')  // ????? as Bloodhound 

declare var UnimatUtils: any

export type TUniAutoCompleteOptions = {
    getUrl: string
    displayKey: string
    modelKey: string
    queryUrl: string
    trim: boolean
    onSelected: (suggestion: any) => void
    onClear: () => void
}

    ; (function() {
        "use strict"

        var _autocomp = function(
            $typeahead: typeof $typeaheadCtrl,
            $autoCache: typeof $autoCacheController,
            $timeout: ng.ITimeoutService,
            $http: ng.IHttpService
        ) {
            return {
                restrict: "AC", // Only apply on an attribute or class
                require: "ngModel", // The two-way data bound value that is returned by the
                // directive
                scope: {
                    // datasets : '=',
                    options: "=", // displayKey, searchUrl,
                    allowCustom: "<"
                },

                link: function(scope, element, attrs, ngModel) {
                    console.log("autocomplete.", scope)

                    scope.selected = null

                    var autosearcher = new _Bloodhound({
                        datumTokenizer: (d: { value: string }) => {
                            return Bloodhound.tokenizers.whitespace(d.value)
                        },
                        queryTokenizer: _Bloodhound.tokenizers.whitespace,
                        remote: {
                            url: scope.options.queryUrl,
                            wildcard: "%QUERY",
                            ajax: {
                                type: "GET",
                                dataType: "json",
                                contentType: "application/json; charset=utf-8",
                                success: function(data) {
                                    if (data.length == 0)
                                        $("#loading").html("Sin resultados en la búsqueda")
                                    else if (data.length > 0) $("#loading").hide()
                                },
                                complete: function(response) { },
                                beforeSend: function() {
                                    $("#loading").html(
                                        "<img src='" +
                                        UnimatUtils._contexto +
                                        "/images/loading.gif" +
                                        "'/> Buscando..."
                                    )
                                    $("#loading").show()
                                },
                                error: function(jqxhr, settings, thrownError) {
                                    $("#loading").html("Error en la búsqueda: " + thrownError)
                                }
                            }
                        } as any
                    })
                    autosearcher.initialize()

                    scope.datasets = {
                        displayKey: getDisplayValue,
                        source: autosearcher.ttAdapter(),
                        limit: 10
                    }

                    /*
                    scope.options = {
                      displayKey : 'nombre',
                      hint : true,
                      minLength : 3,
                      highlight : true
                    };
                    */

                    var initialized = false
                    var options = {
                        hint: true,
                        minLength: 3,
                        highlight: true
                    }
                    var datasets
                    // Unsubscribe handle for the scope watcher
                    var unsubscribe = null
                    // Remembers whether the `datasets` parameter provided was an array or
                    // an object.
                    var datasetsIsArray

                    // Create the typeahead on the element
                    initialize()

                    // Watch for changes on datasets
                    watchDatasets()

                    scope.$watch(
                        function() {
                            return ngModel.$modelValue
                        },
                        function(val) {
                            console.log("autocomplete.========> ", val)

                            if (val) {
                                // no cambiar si viene de selección typeahead
                                if (
                                    scope.selected &&
                                    typeof scope.selected == "object" &&
                                    scope.selected[scope.options.modelKey] == val
                                )
                                    console.log("autocomplete.Sin cambios en el modelo")
                                else {

                                    /*
                                    scope.selected = {}
                                    scope.selected.$visible = scope.selected[
                                      scope.options.modelKey
                                    ] = val
                                    */

                                    // TODO : hacer búsqueda del valor
                                    // $http.get ....

                                    if (scope.options.getUrl) {
                                        var url = scope.options.getUrl.replace(
                                            "%QUERY",
                                            !!scope.options.notrim
                                                ? ngModel.$modelValue
                                                : _.trim(ngModel.$modelValue)
                                        )
                                        $http
                                            .get(url)
                                            .then(({ data, status, headers, config }) => {
                                                if (data instanceof Array) {
                                                    if (data.length == 1) {
                                                        updateVisible(data[0], ngModel.$modelValue)
                                                    } else if (data.length > 1) {
                                                        alert(
                                                            "Encontrados más de una coincidencia para el valor " +
                                                            ngModel.$modelValue +
                                                            ". Por favor, reporta esto como incidencia"
                                                        )
                                                    }
                                                } else if (typeof data == "object") {
                                                    updateVisible(data, ngModel.$modelValue)
                                                } else if (
                                                    typeof data == "string" ||
                                                    typeof data == "number"
                                                ) {
                                                    var result: {
                                                        $visible: any
                                                    } = {} as any
                                                    result[scope.options.modelKey] = ngModel.$modelValue
                                                    result.$visible = data

                                                    updateVisible(result, ngModel.$modelValue)
                                                } else {
                                                    updateVisible(null, ngModel.$modelValue)
                                                }
                                            })
                                            .catch(() => updateVisible(null, ngModel.$modelValue))
                                    } else {
                                        var result: {
                                            $visible: any
                                        } = {} as any
                                        result.$visible = result[scope.options.modelKey] =
                                            ngModel.$modelValue

                                        updateVisible(null, ngModel.$modelValue)
                                    }
                                }
                            } else scope.selected = {}
                        }
                    )

                    // Parses and validates what is going to be set to model (called when:
                    // ngModel.$setViewValue(value))
                    ngModel.$parsers.push(function(fromView) {
                        // In Firefox, when the typeahead field loses focus, it fires an
                        // extra
                        // angular input update event. This causes the stored model to be
                        // replaced with the search string. If the typeahead search string
                        // hasn't changed at all (the 'val' property doesn't update until
                        // after the event loop finishes), then we can bail out early and
                        // keep
                        // the current model value.
                        if (
                            angular.isObject(ngModel.$modelValue) &&
                            fromView === getDatumValue(ngModel.$modelValue)
                        ) {
                            return ngModel.$modelValue
                        }

                        if (!isCustomAllowed() && typeof fromView === "string") {
                            return ngModel.$modelValue
                        }

                        if (angular.isObject(fromView) && fromView[scope.options.modelKey])
                            return fromView[scope.options.modelKey]

                        return fromView
                    })

                    // Formats what is going to be displayed (called when: $scope.model = {
                    // object })
                    ngModel.$formatters.push(function(fromModel) {
                        if (angular.isObject(fromModel)) {
                            fromModel = getDatumValue(fromModel)
                        }

                        if (!fromModel) {
                            $typeahead(element, "val", "")
                        } else {
                            $typeahead(element, "val", fromModel)
                        }
                        return fromModel
                    })

                    function watchDatasets() {
                        unsubscribe = datasetsIsArray
                            ? scope.$watchCollection("datasets", datasetsChangeHandler)
                            : scope.$watch("datasets", datasetsChangeHandler)
                    }

                    function datasetsChangeHandler(newValue, oldValue) {
                        if (angular.equals(newValue, oldValue)) {
                            return
                        }
                        var oldDatasetsIsArray = datasetsIsArray
                        initialize()
                        if (datasetsIsArray !== oldDatasetsIsArray) {
                            unsubscribe()
                            watchDatasets()
                        }
                    }

                    function initialize() {
                        if (scope.datasets == null) {
                            throw new Error("The datasets parameter is mandatory!")
                        }

                        options = angular.extend({}, scope.options, options)
                        datasetsIsArray = angular.isArray(scope.datasets)
                        datasets = datasetsIsArray ? scope.datasets : [scope.datasets]

                        if (!initialized) {
                            $typeahead(element, options, datasets)
                            scope.$watch("autocomplete.options", initialize)

                            $(element).blur(function() {
                                console.log("autocomplete.blur", autosearcher, scope.selected)

                                let selected = ngModel.$modelValue &&
                                    scope.selected

                                var v = (selected &&
                                    (selected.$visible ||
                                        selected[scope.options.modelKey])) ||
                                    ""

                                _update_val(v, scope, ngModel)

                                // si es vacío, no hay selección, lanzar onSelected
                                !v && scope.options.onClear && scope.options.onClear()
                            })

                            initialized = true
                        } else {
                            $typeahead(element, "destroy")
                            $typeahead(element, options, datasets)
                        }
                    }

                    // Returns the string to be displayed given some datum
                    function getDatumValue(datum) {
                        for (var i in datasets) {
                            var dataset = datasets[i]
                            var displayKey = dataset.displayKey || "value"
                            var value =
                                (angular.isFunction(displayKey)
                                    ? displayKey(datum)
                                    : datum[displayKey]) || ""
                            return value
                        }
                    }

                    function isCustomAllowed() {
                        return scope.allowCustom === undefined || !!scope.allowCustom
                    }

                    function updateScope(suggestion) {
                        scope.$apply(function() {
                            ngModel.$setViewValue(suggestion)
                            scope.selected = suggestion
                            scope.selected.$visible = getDisplayValue(suggestion)

                            // soportar evento en selección
                            suggestion && scope.options.onSelected && scope.options.onSelected(suggestion)
                        })
                    }

                    function getDisplayValue(o) {
                        let _v =
                            o.$visible ||
                            (angular.isFunction(scope.options.displayKey)
                                ? scope.options.displayKey(o)
                                : o[scope.options.displayKey] || o[scope.options.modelKey])

                        return scope.options.trim ? _.trim(_v) : _v
                    }

                    function updateVisible(result, model) {
                        var v
                        if (!result) {
                            result = {}
                            v = result.$visible = result[scope.options.modelKey] = model
                        } else {
                            scope.selected = result
                            v = result.$visible = getDisplayValue(result) || model
                        }

                        _update_val(v, scope, ngModel)
                    }

                    function _update_val(v, scope, ngModel) {
                        $timeout(() => {
                            console.log("autocomplete.after get -> __", v, "__", ngModel)

                            $(element).val(v)
                        })
                    }

                    function forwardEvent(name) {
                        element.bind(name, function() {
                            scope.$emit(name, Array.prototype.slice.call(arguments, 1))
                        })
                    }

                    // Update the value binding when a value is manually selected from the
                    // dropdown.
                    element.bind("typeahead:selected", function(evt, suggestion, dataset) {
                        updateScope(suggestion)
                        console.debug("autocomplete.typeahead:selected")
                        scope.$emit("typeahead:selected", suggestion, dataset)
                    })

                    // Update the value binding when a query is autocompleted.
                    element.bind("typeahead:autocomplete", function(
                        evt,
                        suggestion,
                        dataset
                    ) {
                        console.debug("autocomplete.typeahead:autocomplete")
                        updateScope(suggestion)
                        scope.$emit("typeahead:autocomplete", suggestion, dataset)
                    })

                    forwardEvent("typeahead:active")
                    forwardEvent("typeahead:idle")
                    forwardEvent("typeahead:open")
                    forwardEvent("typeahead:close")
                    forwardEvent("typeahead:change")
                    forwardEvent("typeahead:render")
                    forwardEvent("typeahead:cursorchange")
                    forwardEvent("typeahead:asyncrequest")
                    forwardEvent("typeahead:asynccancel")
                    forwardEvent("typeahead:asyncreceive")
                }
            }
        }

        let $typeaheadCtrl = function(subject: any) {
            subject.typeahead.apply(subject, Array.prototype.slice.call(arguments, 1))
        }

        // The actual directive
        angular.module("UP").value("$typeahead", $typeaheadCtrl)

        var $autoCacheController = function(subject: any) {
            return {}
        }

        angular.module("UP").value("$autoCache", $autoCacheController)

        angular
            .module("UP")
            .directive("uniAuto", [
                "$typeahead",
                "$autoCache",
                "$timeout",
                "$http",
                _autocomp
            ])
    })()
